// Legal pages content (Impressum, Datenschutz, AGB)

import { DATENSCHUTZ_HTML_DE } from "@/i18n/legalContent/datenschutzHtml";
import { AGB_HTML_DE } from "@/i18n/legalContent/agbHtml";

const PH = (de, en = de) => ({ de, en });

export const LEGAL = {
  back: { de: "Zurück zur Startseite", en: "Back to home" },
  placeholderBadge: { de: "Platzhalter — bitte ergänzen", en: "Placeholder — please complete" },

  impressum: {
    meta: {
      title: { de: "Impressum", en: "Impressum" },
      overline: { de: "Rechtliche Angaben", en: "Legal information" },
      intro: {
        de: "Petra Osterode — NFC-Aufsteller für lokale Unternehmen.",
        en: "Petra Osterode — NFC stands for local businesses.",
      },
    },
    sections: [
      {
        title: PH("Anbieter", "Provider"),
        items: [
          PH("Petra Osterode"),
          PH("NFC-Aufsteller für lokale Unternehmen"),
          PH("Dubliner Str. 17"),
          PH("30982 Pattensen"),
        ],
      },
      {
        title: PH("Kontakt", "Contact"),
        items: [
          PH("Telefon: 01725263514"),
          PH("Telefax: 051019904079"),
          PH("E-Mail: info@femmesonlinebusiness.com"),
        ],
      },
      {
        title: PH("Umsatzsteuer-ID", "VAT ID"),
        items: [
          PH("Umsatzsteuer-Identifikationsnummer gemäß § 27 a Umsatzsteuergesetz:"),
          PH("StNr.: 23/132/05155"),
        ],
      },
      {
        title: PH("Berufsbezeichnung und berufsrechtliche Regelungen", "Professional title and regulations"),
        items: [
          PH("Berufsbezeichnung:"),
          PH("Onlinedienstleisterin für digitales Marketing"),
          PH("Verliehen in:"),
          PH("Deutschland"),
        ],
      },
      {
        title: PH("Redaktionell verantwortlich", "Editorial responsibility"),
        items: [PH("Petra Osterode")],
      },
      {
        title: PH("Verbraucherstreitbeilegung / Universalschlichtungsstelle", "Consumer dispute resolution"),
        items: [
          PH(
            "Wir sind nicht bereit oder verpflichtet, an Streitbeilegungsverfahren vor einer Verbraucherschlichtungsstelle teilzunehmen.",
            "We are not willing or obliged to participate in dispute resolution proceedings before a consumer arbitration board."
          ),
        ],
      },
    ],
  },

  datenschutz: {
    meta: {
      title: { de: "Datenschutzerklärung", en: "Datenschutzerklärung" },
      overline: { de: "Ihre Daten bei in7sekunden", en: "Ihre Daten bei in7sekunden" },
      intro: {
        de: "Wir nehmen den Schutz Ihrer personenbezogenen Daten ernst und behandeln sie vertraulich und entsprechend der EU-Datenschutz-Grundverordnung (DSGVO) sowie dem Bundesdatenschutzgesetz (BDSG).",
        en: "Wir nehmen den Schutz Ihrer personenbezogenen Daten ernst und behandeln sie vertraulich und entsprechend der EU-Datenschutz-Grundverordnung (DSGVO) sowie dem Bundesdatenschutzgesetz (BDSG).",
      },
    },
    html: { de: DATENSCHUTZ_HTML_DE, en: DATENSCHUTZ_HTML_DE },
  },

  datenschutzEmail: {
    meta: {
      title: { de: "Datenschutz für E-Mail-Signatur", en: "Datenschutz für E-Mail-Signatur" },
      overline: { de: "Hinweise zur E-Mail-Kommunikation", en: "Hinweise zur E-Mail-Kommunikation" },
      intro: {
        de: "Datenschutzinformationen zur Kontaktaufnahme per E-Mail.",
        en: "Datenschutzinformationen zur Kontaktaufnahme per E-Mail.",
      },
    },
    html: {
      de: `
<h2>Datenschutzinformationen</h2>
<p>Wenn Sie uns per E-Mail kontaktieren, verarbeiten wir Ihre personenbezogenen Daten nur, soweit an der Verarbeitung ein berechtigtes Interesse besteht (Art. 6 Abs. 1 lit. f DSGVO), Sie in die Datenverarbeitung eingewilligt haben (Art. 6 Abs. 1 lit. a DSGVO), die Verarbeitung für die Anbahnung, Begründung, inhaltliche Ausgestaltung oder Änderung eines Rechtsverhältnisses zwischen Ihnen und uns erforderlich sind (Art. 6 Abs. 1 lit. b DSGVO) oder eine sonstige Rechtsnorm die Verarbeitung gestattet. Ihre personenbezogenen Daten verbleiben bei uns, bis Sie uns zur Löschung auffordern, Ihre Einwilligung zur Speicherung widerrufen oder der Zweck für die Datenspeicherung entfällt (z.&nbsp;B. nach abgeschlossener Bearbeitung Ihres Anliegens). Zwingende gesetzliche Bestimmungen – insbesondere steuer- und handelsrechtliche Aufbewahrungsfristen – bleiben unberührt. Sie haben jederzeit das Recht, unentgeltlich Auskunft über Herkunft, Empfänger und Zweck Ihrer gespeicherten personenbezogenen Daten zu erhalten. Ihnen steht außerdem ein Recht auf Widerspruch, auf Datenübertragbarkeit und ein Beschwerderecht bei der zuständigen Aufsichtsbehörde zu. Ferner können Sie die Berichtigung, die Löschung und unter bestimmten Umständen die Einschränkung der Verarbeitung Ihrer personenbezogenen Daten verlangen. Details entnehmen Sie unserer <a href="/datenschutz">Datenschutzerklärung</a>.</p>
`,
      en: `
<h2>Datenschutzinformationen</h2>
<p>Wenn Sie uns per E-Mail kontaktieren, verarbeiten wir Ihre personenbezogenen Daten nur, soweit an der Verarbeitung ein berechtigtes Interesse besteht (Art. 6 Abs. 1 lit. f DSGVO), Sie in die Datenverarbeitung eingewilligt haben (Art. 6 Abs. 1 lit. a DSGVO), die Verarbeitung für die Anbahnung, Begründung, inhaltliche Ausgestaltung oder Änderung eines Rechtsverhältnisses zwischen Ihnen und uns erforderlich sind (Art. 6 Abs. 1 lit. b DSGVO) oder eine sonstige Rechtsnorm die Verarbeitung gestattet. Ihre personenbezogenen Daten verbleiben bei uns, bis Sie uns zur Löschung auffordern, Ihre Einwilligung zur Speicherung widerrufen oder der Zweck für die Datenspeicherung entfällt (z.&nbsp;B. nach abgeschlossener Bearbeitung Ihres Anliegens). Zwingende gesetzliche Bestimmungen – insbesondere steuer- und handelsrechtliche Aufbewahrungsfristen – bleiben unberührt. Sie haben jederzeit das Recht, unentgeltlich Auskunft über Herkunft, Empfänger und Zweck Ihrer gespeicherten personenbezogenen Daten zu erhalten. Ihnen steht außerdem ein Recht auf Widerspruch, auf Datenübertragbarkeit und ein Beschwerderecht bei der zuständigen Aufsichtsbehörde zu. Ferner können Sie die Berichtigung, die Löschung und unter bestimmten Umständen die Einschränkung der Verarbeitung Ihrer personenbezogenen Daten verlangen. Details entnehmen Sie unserer <a href="/datenschutz">Datenschutzerklärung</a>.</p>
`,
    },
  },

  agb: {
    meta: {
      title: { de: "Allgemeine Geschäftsbedingungen", en: "Allgemeine Geschäftsbedingungen" },
      overline: { de: "AGB", en: "AGB" },
      intro: {
        de: "für die Erbringung von Dienstleistungen von petra osterode -Femmesmarketing.",
        en: "für die Erbringung von Dienstleistungen von petra osterode -Femmesmarketing.",
      },
    },
    html: { de: AGB_HTML_DE, en: AGB_HTML_DE },
  },

};

export function lget(obj, lang) {
  if (!obj) return "";
  if (typeof obj === "string") return obj;
  return obj[lang] ?? obj.de ?? "";
}
